import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { toast } from "../common/notify";
import { ApiResponse, ApiStatus } from "../api/ApiUtilities";
import { getUser } from "../api/AuthApi";
import { getMeetingStatus, UnauthorisedError } from "../api/MeetingApi";
import { GetHasSessionInPersonValueBeenSet, SetSessionInPersonValue } from "../api/Session";
import { getStatusMeetingStatus } from "../api/StatusApi";
import { updateMyDetails } from "../api/UserActions";
import { getCookieValue } from "../api/Utilities";
import ContainerCard from "../common/CardContainer";
import PageHeader from "../common/PageHeader";
import ZoomDetails from "../components/dashboard/ZoomDetails";
import { MeetingStatus } from "../data/MeetingStatus";
import { User } from "../data/User";
import { logoutAction, myUserUpdatedAction, updateMeetingStatusAction } from "../state/actions";
import { SLinkContext } from "../state/context";
//import PropTypes from "prop-types";
//ParticipantDashboardView.propTypes = {};
import "./Resources.css";

function ParticipantDashboardView(props: any) {
  const { state, dispatch } = useContext(SLinkContext);
  const [apiUser, setApiUser] = useState<User | null>();
  const [apiError, setApiError] = useState<string>("");
  const [meetingStatus, setMeetingStatus] = useState<MeetingStatus | null>(null);
  const [setIsInPerson, setSetIsInPerson] = useState(true);

  // TODO: move this useEffect to logged in layout so it runs once on login and then only as required by different screens
  useEffect(() => {
    getMeetingStatus()
      .then((status) => {
        dispatch(updateMeetingStatusAction(status));
      })
      .catch((error: Error) => {
        if (error instanceof UnauthorisedError) {
          dispatch(logoutAction());
        }
      });
  }, []);

  useEffect(() => {
    console.log("State session ask if is in person: " + state.meetingStatus?.askIsInPerson + " - has been set: " + GetHasSessionInPersonValueBeenSet());
    if (state.meetingStatus?.askIsInPerson && !GetHasSessionInPersonValueBeenSet()) {
      setSetIsInPerson(false);
    }
  }, [state.meetingStatus, state.meetingStatus?.askIsInPerson]);

  /*function shouldAskForInPersonOrNot() {
    if (state.meetingStatus === null) {
      return false; // don't ask if there is no meeting in progress
    }
    if (state.meetingStatus.askIsInPerson === false) {
      return false; // don't ask if the session indicates not to ask
    }
    if (GetHasSessionInPersonValueBeenSet()) {
      return false; // don't ask if already asked
    }
    console.log("NO HAS SESSION VALUE BEEN SET ***************************");
    return true;
  }
  useEffect(() => {
    shouldAskForInPersonOrNot();
  }, [state.meetingStatus, state.meetingStatus?.askIsInPerson]);
  */

  function handleCloseSetIsInPerson() {
    handleCloseIsInPersonDialog(true);
  }
  function handleCloseIsInPersonDialog(isInPerson: boolean) {
    SetSessionInPersonValue(isInPerson);
    // call update to user here with setting value if not already set that way
    if (state.user?.isInPerson !== isInPerson) {
      // call api to update
      var userModel = {
        ...state.user,
        isInPerson: isInPerson,
      } as User;
      updateMyDetails(userModel)
        .then((response: ApiResponse<User>) => {
          if (response.status === ApiStatus.Ok && response.data != null) {
            dispatch(myUserUpdatedAction(response.data));
          } else if (response.status === ApiStatus.Unauthorised) {
            dispatch(logoutAction());
          }
          toast.success("Updated successfully");
        })
        .catch((error: Error) => {
          toast.error(`Error updating your is in person preference. Details: ${error.message}`);
        });
    }
    setSetIsInPerson(true);
  }
  function handleCloseSetNotIsInPerson() {
    handleCloseIsInPersonDialog(false);
  }

  const isParticipant = state.user?.userRoles.split(",").includes("Participant");
  const meetingLive = state.meetingStatus?.enableParticipantView === true;

  return (
    <div>
      <PageHeader title={`Welcome${state.user?.preferredName ? ", " + state.user.preferredName : ""}`} subtitle="Anglican Diocese of Melbourne — Synod" />

      {meetingLive && isParticipant ? (
        <div className="sl-cta-card" role="status">
          <span className="sl-cta-text">A meeting of Synod is in progress.</span>
          <NavLink to="/dashboard/meeting" className="btn btn-primary">
            Go to the meeting
          </NavLink>
        </div>
      ) : null}

      <div className="row">
        <div className="col-lg-8">
          <ContainerCard heading="Getting started">
            <p>
              Welcome to the Diocese of Melbourne Synod portal. A{" "}
              <a href="https://www.youtube.com/watch?v=ThVMmMOC9V0" rel="noreferrer" target="_blank">
                video tutorial
              </a>{" "}
              shows how to navigate this site.
            </p>
            <p className="mb-0">You may need to click the video to make it play the first time if the video does not auto play on your device.</p>
          </ContainerCard>
          <ContainerCard heading="Synod Papers">
            <p className="text-muted mb-0">No notice papers available.</p>
            {/* <a className="btn btn-link px-0" href="https://adom.synod.link/resources/Daily+Notice+Paper+12+October+2024.pdf" target="_blank" rel="noreferrer">
              Daily Notice Paper - 12th October 2024
            </a> */}
          </ContainerCard>
        </div>
        <div className="col-lg-4">
          <ContainerCard heading="Help during Synod">
            <p>
              Tech help desk: <a href="tel:0396534282">9653 4282</a>
            </p>
            <p className="mb-0">
              For all matters not pertinent to the active item of business: <a href="mailto:synod@melbourneanglican.org.au">synod@melbourneanglican.org.au</a>
            </p>
          </ContainerCard>
        </div>
      </div>

      <Modal show={!setIsInPerson} onHide={handleCloseSetIsInPerson}>
        <Modal.Header>
          <Modal.Title>Attending in Person?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you attending the meeting in person today?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSetNotIsInPerson}>
            No
          </Button>
          <Button variant="primary" onClick={handleCloseSetIsInPerson}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ParticipantDashboardView;
